import { mapActions } from "vuex"

export default {
  data() {
    return {
      is_active: false,
      errorTemplate: ''
    }
  },
  methods: {
    ...mapActions(['updateSystemError']),
    showErrorMessage (text, time = 2000) {
      this.$vs.notify({
        title: 'Error',
        time: time,
        text,
        color:'danger',
        position:'top-right'})
    },
    showWarningMessage (text) {
      this.$vs.notify({
        title: 'Warning',
        text,
        color:'warning',
        position:'top-right'})
    },
    showErrorMessageWithTitle (title, text) {
      this.$vs.notify({
        title: title ? title : 'Error',
        text,
        color:'danger',
        position:'top-right'})
    },
    convertAndNotifyError (err, config={}) {
      if (!(err.response && err.response.data)) return
      let errors = undefined
      let error_out = '<ul style="list-style-type:circle; margin-left:15px">'
      if (err.response.data.errors) {
        errors = err.response.data.errors
        for (const error in errors) {
          const element = errors[error]
          error_out += `<li>${  element[0]  }</li>`
        }
      }
      error_out += '</ul>'
      this.updateSystemError({
        is_active: true,
        messageTemplate: `${err.response.data.message ? err.response.data.message : err.response.data.data ? err.response.data.data.message : ''}<br><br>${error_out}`,
        color: config.color || "danger",
        title: config.title || "An Error Occurred - Please review",
        hideButtons: config.hideButtons ? config.hideButtons : true,
        buttonText: config.buttonText || "Close"
      })
    },
    convertAndNotifySageError (err, config={}) {
      if (!(err.response && err.response.data)) return
      let errors = undefined
      let error_out = '<ul style="list-style-type:circle; margin-left:15px">'
      if (err.response.data.errors) {
        errors = err.response.data.errors
        for (const error in errors) {
          const element = errors[error]
          error_out += `<li>${  element[0]  }</li>`
        }
      }
      error_out += '</ul>'
      this.updateSystemError({
        is_active: true,
        messageTemplate: `${err.response.data.Message ? err.response.data.Message : err.response.data.data ? err.response.data.data.Message : ''}<br><br>${error_out}`,
        color: config.color || "danger",
        title: config.title || "An Error Occurred - Please review",
        hideButtons: config.hideButtons ? config.hideButtons : true,
        buttonText: config.buttonText || "Close"
      })
    },
  },
}
